/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendConfirmationCodeRequest
 */
export interface ResendConfirmationCodeRequest {
    /**
     * User's email.
     * @type {string}
     * @memberof ResendConfirmationCodeRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the ResendConfirmationCodeRequest interface.
 */
export function instanceOfResendConfirmationCodeRequest(value: object): boolean {
    return true;
}

export function ResendConfirmationCodeRequestFromJSON(json: any): ResendConfirmationCodeRequest {
    return ResendConfirmationCodeRequestFromJSONTyped(json, false);
}

export function ResendConfirmationCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendConfirmationCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ResendConfirmationCodeRequestToJSON(value?: ResendConfirmationCodeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

